<template>
  <div class="container">
    <h2>{{$t('Forgot password')}}?</h2>
    <ul v-if="returnErrors && returnErrors.length" class="errors-wrapper">
      <li v-for="error of returnErrors">
        {{error}}
      </li>
    </ul>
    <v-form ref="form" v-model="valid" @submit.prevent="submit" lazy-validation>
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              v-model="form.email"
              :rules="emailRules"
              :label="$t('E-mail')"
              type="email"
              required>
            </v-text-field>
          </v-flex>
          <v-flex>
            <div class="button-wrapper" id="buttonwrapper">
              <v-btn :disabled="!valid" type="submit" color="success" @click="submit">{{$t('Submit')}}</v-btn>
            </div>
            <div class="sent-message" v-if="sentMessage">{{sentMessage}}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>
<script>
    import axios from 'axios';
    export default {
        data() {
            return {
                emailRules: [
                    v => !!v || this.$t('Required field'),
                    v => /.+@.+/.test(v) || this.$t('E-mail must be valid')
                ],
                valid: false,
                form: {
                    email: ""
                },
                returnErrors: [],
                sentMessage: false
            }
        },
        methods: {
            validate() {
                if (this.$refs.form.validate()) {
                    redirectToPayments();
                }
            },
            submit(){
                if (this.$refs.form.validate()) {
                    let headers = {
                        headers: {
                            token: this.$route.query.token
                        }
                    };
                    axios.post('/generateUserCreatePasswordLink', {
                        email: this.form.email,
                    }, headers)
                        .then(response => {
                            if (response.status === 200) {
                                document.getElementById('buttonwrapper').style.display = "none";
                                this.sentMessage = this.$t('We sent password confirmation link to your email.');
                            }
                        })
                        .catch(e => {
                            let errors = e.response.data;
                            this.returnErrors = [];
                            for (let key in errors) {
                                this.returnErrors.push(this.$t(errors[key]))
                            }
                        })
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
  .container {max-width: 600px;}
  .errors-wrapper {color: red; background: #ffe6e6; margin: 0 16px 10px; line-height: 24px; border-radius: 2px;}
  .sent-message {background: #E2F3EA; line-height: 30px;}
</style>



// WEBPACK FOOTER //
// src/views/account/ForgotPassword.vue